export const sliderItems = [
  {
    id: 7,
    title: "React Library",
    img: "/imgs/RecatLibrary.png",
    desc: "Liven up your React projects with social media-style reaction animations!",
    link: "https://www.npmjs.com/package/reaction-animation",
  },
  {
    id: 6,
    title: "Discord Clone",
    img: "/imgs/Discord.png",
    desc: "Built real-time chat with video/audio calls in a Discord-like app.",
    link: "https://discord-clone-mu-three.vercel.app/",
  },
  {
    id: 5,
    title: "DevCamper-API",
    img: "/imgs/DevCamper-API.png",
    desc: "Develop production-level secure API and using Postman, generate documentation",
    link: "https://devcamper-api.cyclic.app/",
  },
  {
    id: 4,
    title: "E-commerce",
    img: "/imgs/Ecommerce.png",
    desc: "Ecommerce site with attractive design along with backend.",
    link: "https://hetecommerce.netlify.app/",
  },
  {
    id: 1,
    title: "Keeper App",
    img: "/imgs/KeeperApp.png",
    desc: "A secure platform for user to keep notes of their work.",
    link: "https://developerhet.github.io/keeper-app/",
  },
  {
    id: 2,
    title: "ToDo List",
    img: "/imgs/ToDoListMain.png",
    desc: "User can keep track of the task to be done.",
    link: "https://todo-het.netlify.app/",
  },
  {
    id: 3,
    title: "Movie House",
    img: "/imgs/MovieHouse.png",
    desc: "To keep user updated with new movies and web series.",
    link: "https://developerhet.github.io/movie-fetch-site/",
  },
  // {
  //   id: 5,
  //   title: "Het Patel 5",
  //   img: "https://images.pexels.com/photos/221433/pexels-photo-221433.jpeg",
  //   desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. ",
  // },
];

export const timelineItems = [
  {
    id: 1,
    title: "Software Development Engineer",
    date: "Feb 2024 - Present",
    link: "https://dcx.kandle.xyz/",
    desc: "Implemented real-time player vs player High/Low game functionality with web sockets on the frontend, contributing to approximately 5000 user acquisitions in just 13 days for the company. Optimized application performance by collaborating with the Redux library. Continuously improved app features, resolved bugs, and integrated new functionalities by establishing API connections to enhance the user experience.",
  },
  {
    id: 2,
    title: "Software Engineer Intern - Kandle",
    date: "May 2023 - Aug 2023",
    link: "https://dcx.kandle.xyz/",
    desc: "Developed visually appealing company website utilizing Next.js, emphasizing key features. Gained proficiency in navigating and managing code in large codebases, with expertise in using the version control tool Git and GitHub for safe production system updates. Explored server-side and client-side rendering, gained a high-level understanding of how a service handles an HTTP request.",
  },
  {
    id: 3,
    title: "Website Research Intern - Rashtriya Raksha University",
    date: "Mar 2023 - May 2023",
    link: "https://rru.ac.in/",
    desc: "Maintained university website: updated content, fixed errors, and ensured user-friendliness.Collaborated with cross-functional teams and various stakeholders and implemented a food menu application for the university.",
  },
  // {
  //   id: 2,
  //   title: "Freelance Video Editor",
  //   date: "Mar 2020 - Jun 2022",
  //   link: "https://www.fiverr.com/users/hetpatel2312",
  //   desc:"Created and edited videos for clients, providing creative input and timely delivery. Maintained a 5-star rating on Fiverr, achieving Level One Seller status and positive feedback",
  // },
  // {
  //   id: 3,
  //   title: "Het Patel 3",
  //   date: "2018",
  //   desc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nihil, magnam veritatis. Expedita, nihil! Ex quia aspernatur nemo sapiente dicta dignissimos quaerat laborum officiis.",
  // },
  // {
  //   id: 4,
  //   title: "Het Patel 4",
  //   date: "2019",
  //   desc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nihil, magnam veritatis. Expedita, nihil! Ex quia aspernatur nemo sapiente dicta dignissimos quaerat laborum officiis.",
  // },
  // {
  //   id: 5,
  //   title: "Het Patel 5",
  //   date: "2020",
  //   desc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nihil, magnam veritatis. Expedita, nihil! Ex quia aspernatur nemo sapiente dicta dignissimos quaerat laborum officiis, totam placeat rem maiores corrupti doloribus consequuntur!",
  // },
  // {
  //   id: 6,
  //   title: "Het Patel 6",
  //   date: "2021",
  //   desc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nihil, magnam veritatis. Expedita, nihil! Ex quia aspernatur nemo sapiente dicta dignissimos quaerat laborum officiis, totam placeat rem maiores corrupti doloribus consequuntur!",
  // },
];

export const educationDetails = [
  {
    id: 1,
    std: "University",
    year: " 2020-2024",
    place:
      "Bachelors of Technology in Computer Science and Engineering from Rashtriya Raksha University.",
  },
  {
    id: 2,
    std: "12",
    year: " 2019-2020",
    place: "Completed higher secondary schooling from Vivek Vidhayalay.",
    sup: "th",
  },
  {
    id: 3,
    std: "10",
    year: " 2017-2018",
    place: "Matriculation done from Akshar Jyoti High School",
    sup: "th",
  },
  // {
  //   id: 5,
  //   title: "Het Patel 5",
  //   date: "2020",
  //   desc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nihil, magnam veritatis. Expedita, nihil! Ex quia aspernatur nemo sapiente dicta dignissimos quaerat laborum officiis, totam placeat rem maiores corrupti doloribus consequuntur!",
  // },
  // {
  //   id: 6,
  //   title: "Het Patel 6",
  //   date: "2021",
  //   desc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nihil, magnam veritatis. Expedita, nihil! Ex quia aspernatur nemo sapiente dicta dignissimos quaerat laborum officiis, totam placeat rem maiores corrupti doloribus consequuntur!",
  // },
];
